import React, { useState } from 'react';
import { Play, Youtube, ChevronLeft, ChevronRight } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

const VideoSection = () => {
  const podcasts = [
    { id: 'q46IlgR3S5g', title: 'Da Periferia para o Mundo: O Empreendedorismo como Caminho de Transformação | Rotas para o Nordeste' },
    { id: 'H3QIBfVOX3o', title: 'Podcast Papo Hertz - Uma música produzida a cada episódio - Alysson Takaki' },
    { id: 'diHkQePgIX4', title: 'Guerra entre PALESTINA e ISRAEL na visão ESPIRITUAL com Mayse Braga - Podcast Portal Reação #5' },
    { id: 'AYwiIXuEgws', title: 'Podcast Papo Hertz - Uma música produzida a cada episódio - Diogo Villar (Bloco Eduardo e Mônica)' },
    { id: 'Z67lrJU9UVc', title: 'Elite Cast - Como viralizar no Instagram ou m0rr3r tentando com Oney Araújo' },
    { id: 'WDqsz3ejORA', title: 'Senadora Damares Alves - 8º episódio - Cortadas do Firmino' },
    { id: 'QqMeUU1bpe8', title: 'EliteCast com Luan Portugal | Como ser um Social Media que fatura 10k' },
    { id: '7eVruPtaQFY', title: 'Soraya Thronicke: "Bolsonaro me enganou porque eu permiti" 🇧🇷🗣️' },
    { id: 'voTB3u1DueI', title: 'Sérgio Moro - 19º episódio - Cortadas do Firmino' },
    { id: 'f7IXiutIsWQ', title: 'Dino diz que big techs foram irresponsáveis com 8 de janeiro' },
    { id: 'WGiG9zDa-dY', title: 'ALMATALK | #3 - Saúde Mental dos Trabalhadores - Profª Carla Furtado e Andréa Nunes' },
    { id: 'ePCIBgZ4WXU', title: 'EMPREENDEDORISMO E ALTA PERFORMANCE | Capital Business Podcast 02' },
  ];

  const musicVideos = [
    { id: 'FkaqaMJd_bs', title: '30 Cortes - Mônica Soares, Di Propósito [Clipe Oficial]' },
    { id: '3-gBL7Dc9iA', title: 'Deivid Rodrigues ft. Pedro Paulo e Matheus - O Problema é Você (Piseiro do DR)' },
    { id: 'o7OYZYDgt00', title: 'Sala de Espelhos - Julia Sykes [clipe oficial]' },
    { id: 'iwZ1l7lyoFE', title: 'Mariano Júnior - Não Inventaram Palavras' },
    { id: '9YTLvFH5LKU', title: 'Amanhã Eu Vou te Ver - Mariano Júnior e Thiago Lunar #novosingle' },
    { id: 'KCCurbYatw8', title: 'Amy Winehouse Cover 4ujazz\'n\'roll' },
    { id: 'NokRu89A-aY', title: 'Larissa Gonçalves - Único Deus no Meu Coração' },
    { id: '3paEheI8lwY', title: 'Velha Infância - Tribalistas (Cover: Nathália Cavalcante)' },
    { id: 'WDsuUU7-oJM', title: 'Viva la vida - Coldplay ( Elton Marques / Loop pedal cover )' },
    { id: '2wtmmFO99KU', title: 'GRUPO DI PROPÓSITO - Luau do DP ( completo )' },
    { id: 'RtitK162fDs', title: 'Medley Jazz I - Fly Me to The Moon, I\'ve Got You, The Way You Look Tonight, All Of Me, Fever...' },
    { id: '9jbT4a49UuQ', title: 'Mônica Soares - Nenhuma das canções que eu fiz era pra você - 4k Dixieland' },
  ];

  const [podcastIndex, setPodcastIndex] = useState(0);
  const [musicIndex, setMusicIndex] = useState(0);
  const videosPerPage = 3;

  const VideoCarousel = ({ videos, currentIndex, setIndex }) => {
    const visibleVideos = videos.slice(currentIndex, currentIndex + videosPerPage);
    const hasNext = currentIndex + videosPerPage < videos.length;
    const hasPrev = currentIndex > 0;

    return (
      <div className="relative">
        {/* Navigation Buttons */}
        <button
          onClick={() => setIndex(Math.max(0, currentIndex - videosPerPage))}
          disabled={!hasPrev}
          className={`absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 ${
            hasPrev ? 'hover:bg-[#ff6b35] hover:text-white hover:scale-110' : 'opacity-50 cursor-not-allowed'
          }`}
        >
          <ChevronLeft size={24} />
        </button>

        {/* Videos Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {visibleVideos.map((video, index) => (
            <VideoCard key={index} video={video} />
          ))}
        </div>

        <button
          onClick={() => setIndex(currentIndex + videosPerPage)}
          disabled={!hasNext}
          className={`absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 ${
            hasNext ? 'hover:bg-[#ff6b35] hover:text-white hover:scale-110' : 'opacity-50 cursor-not-allowed'
          }`}
        >
          <ChevronRight size={24} />
        </button>

        {/* Progress Indicator */}
        <div className="flex justify-center items-center space-x-2 mt-8">
          <span className="text-sm text-gray-600">
            {currentIndex + 1} - {Math.min(currentIndex + videosPerPage, videos.length)} de {videos.length}
          </span>
        </div>
      </div>
    );
  };

  const VideoCard = ({ video }) => {
    const [isPlaying, setIsPlaying] = useState(false);

    return (
      <div className="group relative rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 bg-white">
        {!isPlaying ? (
          <div className="relative aspect-video bg-gray-900 cursor-pointer" onClick={() => setIsPlaying(true)}>
            <img
              src={`https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`}
              alt={video.title}
              className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity duration-300"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300 shadow-2xl">
                <Play className="text-white ml-1" size={28} fill="white" />
              </div>
            </div>
            <div className="absolute top-4 right-4">
              <Youtube className="text-white opacity-80" size={24} />
            </div>
          </div>
        ) : (
          <div className="aspect-video">
            <iframe
              src={`https://www.youtube.com/embed/${video.id}?autoplay=1`}
              title={video.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
            />
          </div>
        )}
        <div className="p-4">
          <h3 className="text-sm font-medium text-[#1e3a5f] line-clamp-2 group-hover:text-[#ff6b35] transition-colors duration-300">
            {video.title}
          </h3>
        </div>
      </div>
    );
  };

  return (
    <section id="trabalhos" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 space-y-4">
          <div className="inline-block">
            <span className="text-[#ff6b35] font-semibold text-sm uppercase tracking-wider bg-[#ff6b35]/10 px-4 py-2 rounded-full">
              Nossos Trabalhos
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f]">
            Portfólio de <span className="text-[#ff6b35]">Projetos</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Confira alguns dos projetos que já realizamos
          </p>
        </div>

        {/* Tabs */}
        <Tabs defaultValue="podcasts" className="w-full">
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-2 mb-12 bg-gray-100 p-1 rounded-full">
            <TabsTrigger
              value="podcasts"
              className="rounded-full data-[state=active]:bg-[#ff6b35] data-[state=active]:text-white font-semibold transition-all duration-300"
              onClick={() => setPodcastIndex(0)}
            >
              Podcasts
            </TabsTrigger>
            <TabsTrigger
              value="music"
              className="rounded-full data-[state=active]:bg-[#ff6b35] data-[state=active]:text-white font-semibold transition-all duration-300"
              onClick={() => setMusicIndex(0)}
            >
              Produções Musicais
            </TabsTrigger>
          </TabsList>

          {/* Podcasts Tab */}
          <TabsContent value="podcasts" className="mt-8">
            <VideoCarousel videos={podcasts} currentIndex={podcastIndex} setIndex={setPodcastIndex} />
          </TabsContent>

          {/* Music Videos Tab */}
          <TabsContent value="music" className="mt-8">
            <VideoCarousel videos={musicVideos} currentIndex={musicIndex} setIndex={setMusicIndex} />
          </TabsContent>
        </Tabs>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-600 mb-6">Quer ver seu projeto aqui também?</p>
          <button
            onClick={() => window.open('https://wa.me/5561985533770', '_blank')}
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#ff6b35] to-[#ff8555] text-white font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
          >
            <Youtube className="mr-2" size={20} />
            Iniciar Meu Projeto
          </button>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
